<div class="main-content srb-page">
	<div class="srb-shell">

		<!-- ── Top bar ─────────────────────────────────────────────── -->
		<header class="srb-topbar">
			<div class="srb-topbar-left">
				<i class="material-icons srb-back" (click)="back()">arrow_back</i>
				<h1 class="srb-title">{{ isRep ? 'My week' : 'Sales routes' }}</h1>

				<!-- Manager: pick who you're planning for. Rep: it's just you. -->
				<ng-container *ngIf="!isRep">
					<select class="srb-sel srb-sel-rep" [formControl]="salesmanCtrl" (change)="onSalesmanChange()" aria-label="Salesperson">
						<option value="">Salesperson…</option>
						<option *ngFor="let sp of salespeople" [value]="sp.salesmancode">{{ sp.salesmancode }} — {{ sp.salesmanname }}</option>
					</select>
					<select class="srb-sel srb-sel-terr" [formControl]="territoryCtrl" (change)="loadAccounts()" aria-label="Territory">
						<option value="">All territories</option>
						<option *ngFor="let t of territories" [value]="t.territory_id">{{ t.territory_name }}</option>
					</select>
					<button mat-icon-button type="button" class="srb-reload" (click)="loadAccounts()" [disabled]="loadingAccounts || loadingMeta" title="Reload accounts">
						<i class="material-icons" [class.srb-spin]="loadingAccounts">sync</i>
					</button>
				</ng-container>
				<span class="srb-repname" *ngIf="isRep && repName">{{ repName }}</span>
			</div>

			<div class="srb-topbar-week">
				<button mat-icon-button type="button" (click)="prevWeek()" aria-label="Previous week"><i class="material-icons">chevron_left</i></button>
				<div class="srb-week-text">
					<strong>{{ weekLabel() }}</strong>
					<a (click)="thisWeek()">This week</a>
				</div>
				<button mat-icon-button type="button" (click)="nextWeek()" aria-label="Next week"><i class="material-icons">chevron_right</i></button>
			</div>

			<div class="srb-topbar-actions">
				<button type="button" class="srb-savestate" [class.is-dirty]="unsaved || saving" (click)="saveWeek()" [disabled]="saving || !salesmanCtrl.value" title="Your changes save on their own — tap to save right now">
					{{ saving ? 'Saving…' : (unsaved ? 'Tap to save now' : (loadingWeek ? 'Loading…' : 'Saved')) }}
				</button>
				<button mat-icon-button type="button" (click)="openAi()" title="Build my week automatically"><i class="material-icons">auto_awesome</i></button>
				<button *ngIf="!isRep" mat-icon-button type="button" (click)="showSettings = !showSettings" title="Route settings"><i class="material-icons">settings</i></button>
				<button mat-icon-button type="button" (click)="openInMaps()" [disabled]="!activeStops.length" title="Open this day in Google Maps"><i class="material-icons">map</i></button>
				<button mat-icon-button type="button" (click)="printRoute()" title="Print"><i class="material-icons">print</i></button>
				<button mat-raised-button color="accent" type="button" class="srb-start" (click)="startDay()" [disabled]="!salesmanCtrl.value" title="Start driving this day">
					<i class="material-icons">play_arrow</i> Start driving
				</button>
			</div>
		</header>

		<!-- ── Day strip ───────────────────────────────────────────── -->
		<div class="srb-daystrip">
			<div class="srb-day-tabs">
				<ng-container *ngFor="let d of plannerDays">
					<span class="srb-week-sep" *ngIf="d.newWeek">next week</span>
					<button type="button" class="srb-day-tab" [class.is-active]="isActiveDay(d)" [class.is-today]="d.isToday" (click)="selectDay(d)">
						<span class="srb-day-label">{{ d.label }} <em>{{ d.dateShort }}</em></span>
						<span class="srb-day-count" *ngIf="dayCount(d.weekStart, d.dow)">{{ dayCount(d.weekStart, d.dow) }}</span>
					</button>
				</ng-container>
			</div>
			<span class="srb-total">{{ totalStops() }} stops<ng-container *ngIf="weekMiles() > 0"> · about {{ weekMiles() | number:'1.0-0' }} mi total</ng-container></span>
			<span class="srb-day-actions">
				<button mat-button type="button" *ngIf="lastWeekHadPlan && !totalStops()" (click)="copyLastWeek()">Use last week</button>
				<button mat-stroked-button type="button" class="srb-templates-btn" (click)="showTemplates = !showTemplates; showDayTools = false">
					<i class="material-icons">library_books</i> Saved routes
				</button>
				<button mat-stroked-button type="button" class="srb-daytools-btn" (click)="showDayTools = !showDayTools; showTemplates = false">
					<i class="material-icons">more_horiz</i> More
				</button>
				<button mat-stroked-button type="button" class="srb-viewtoggle" (click)="toggleListView()" [title]="listView ? 'Map view' : 'List view'">
					<i class="material-icons">{{ listView ? 'map' : 'view_list' }}</i> {{ listView ? 'Map' : 'List' }}
				</button>
			</span>

			<!-- Day tools dropdown -->
			<div class="srb-popover-backdrop" *ngIf="showDayTools" (click)="showDayTools = false"></div>
			<div class="srb-popover" *ngIf="showDayTools">
				<ng-container *ngFor="let d of days">
					<button type="button" class="srb-popover-item" *ngIf="d.dow !== activeDow && dayCount(activeWeekStart, d.dow)" (click)="copyDay(d.dow); showDayTools = false">
						<i class="material-icons">content_copy</i> Copy {{ d.label }} → {{ activeDayLabel() }}
					</button>
				</ng-container>
				<button type="button" class="srb-popover-item" [disabled]="!activeStops.length" (click)="openTemplateSave(); showDayTools = false">
					<i class="material-icons">bookmark_border</i> Save {{ activeDayLabel() }} as a reusable route
				</button>
				<button *ngIf="!isRep" type="button" class="srb-popover-item" (click)="openTerritoryMgr(); showDayTools = false">
					<i class="material-icons">explore</i> Territory manager
				</button>
				<button type="button" class="srb-popover-item is-warn" [disabled]="!activeStops.length" (click)="clearDay(); showDayTools = false">
					<i class="material-icons">delete_sweep</i> Empty {{ activeDayLabel() }}
				</button>
			</div>

			<!-- Templates dropdown -->
			<div class="srb-popover-backdrop" *ngIf="showTemplates" (click)="showTemplates = false"></div>
			<div class="srb-popover srb-popover-wide" *ngIf="showTemplates">
				<div class="srb-popover-head">
					<strong>Apply saved route → {{ activeDayLabel() }}</strong>
					<select class="srb-sel" [formControl]="templateZoneCtrl" (change)="loadTemplates()" aria-label="Zone">
						<option value="">All zones</option>
						<option *ngFor="let z of templateZones" [value]="z.zone">{{ z.zone }} ({{ z.n }})</option>
					</select>
				</div>
				<div class="srb-template-list">
					<p class="text-muted srb-empty" *ngIf="loadingTemplates">Loading templates…</p>
					<div class="srb-template-row" *ngFor="let t of templates">
						<span class="srb-template-name">{{ t.route_name }} <em>{{ t.zone }} · {{ t.estimated_stops }} stops</em></span>
						<button mat-stroked-button color="primary" type="button" (click)="applyTemplate(t); showTemplates = false" [disabled]="applyingTemplate">Apply</button>
					</div>
					<p class="text-muted srb-empty" *ngIf="!loadingTemplates && !templates.length">No templates for this zone.</p>
				</div>
			</div>
		</div>

		<!-- ── Route settings strip ────────────────────────────────── -->
		<section class="srb-settings" *ngIf="showSettings">
			<p class="srb-settings-scope">
				Editing the start/end point for <strong>{{ activeDayLabel() }}</strong> only — other days in this week keep their own.
				<button mat-button type="button" *ngIf="hasDayOverride" (click)="clearDayOverride()" title="Revert to the week's usual start/end">Use the week's default instead</button>
			</p>
			<div class="srb-settings-row">
				<label>Start point</label>
				<span class="srb-hb">{{ effHomeBaseLabel || 'Home base' }} <em *ngIf="effHomeBaseLat != null">({{ effHomeBaseLat | number:'1.3-3' }}, {{ effHomeBaseLng | number:'1.3-3' }})</em><em *ngIf="effHomeBaseLat == null" class="srb-warn">not set</em></span>
				<input class="srb-inp" [(ngModel)]="startAddr" placeholder="Type a start address…" (keyup.enter)="saveStartAddress()">
				<button mat-stroked-button type="button" (click)="saveStartAddress()" [disabled]="geocoding || !startAddr.trim()">Set</button>
				<button mat-stroked-button type="button" [class.srb-onmap]="settingPoint==='start'" (click)="setPoint('start')" title="Tap the map to set it"><i class="material-icons">touch_app</i> {{ settingPoint==='start' ? 'Tap the map…' : 'Pick on map' }}</button>
			</div>
			<div class="srb-settings-row">
				<label>End point</label>
				<select [(ngModel)]="effEndModeModel" class="srb-sel">
					<option value="home">Return to start</option>
					<option value="last">End at last stop (one-way)</option>
					<option value="custom">Custom end point</option>
				</select>
				<ng-container *ngIf="effEndMode === 'custom'">
					<span class="srb-hb" *ngIf="effEndLabel">{{ effEndLabel }} <em *ngIf="effEndLat != null">({{ effEndLat | number:'1.3-3' }}, {{ effEndLng | number:'1.3-3' }})</em></span>
					<input class="srb-inp" [(ngModel)]="endAddr" placeholder="Type an end address…" (keyup.enter)="saveCustomEnd()">
					<button mat-stroked-button type="button" (click)="saveCustomEnd()" [disabled]="geocoding || !endAddr.trim()">Set</button>
					<button mat-stroked-button type="button" [class.srb-onmap]="settingPoint==='end'" (click)="setPoint('end')" title="Tap the map to set it"><i class="material-icons">touch_app</i> {{ settingPoint==='end' ? 'Tap the map…' : 'Pick on map' }}</button>
					<button mat-icon-button type="button" (click)="clearEnd()" title="Clear custom end"><i class="material-icons">close</i></button>
				</ng-container>
			</div>
		</section>

		<!-- ── Banners ─────────────────────────────────────────────── -->
		<div class="srb-draft-banner" *ngIf="draftRestored">
			<span>Restored unsaved changes for this week.</span>
			<button mat-button type="button" (click)="keepDraft()">Keep</button>
			<button mat-button type="button" (click)="discardDraft()">Discard</button>
		</div>
		<!-- Floating toast: auto-dismisses, offers Undo after bulk edits -->
		<div class="srb-status" *ngIf="status" role="status">
			<span class="srb-status-msg">{{ status }}</span>
			<button type="button" class="srb-status-undo" *ngIf="canUndo" (click)="undoLast()">Undo</button>
			<i class="material-icons" (click)="status = null">close</i>
		</div>
		<p class="text-warning srb-map-msg" *ngIf="mapError">{{ mapError }}</p>
		<div class="srb-nosm" *ngIf="metaLoaded && !salesmanCtrl.value && !isRep">
			Pick a salesperson to load their accounts and saved weeks.
		</div>
		<div class="srb-nosm" *ngIf="metaLoaded && !salesmanCtrl.value && isRep">
			We couldn't tell which salesperson you are. Ask your manager to connect your login to your salesperson code, then your customers and week will show up here.
		</div>

		<!-- ── Workspace: side panel + map ─────────────────────────── -->
		<div class="srb-workspace">
			<aside class="srb-panel">
				<nav class="srb-panel-tabs">
					<button type="button" [class.is-active]="sideTab === 'route'" (click)="setSideTab('route')">
						{{ activeDayLabel() }} plan <span class="srb-tab-n" *ngIf="activeStops.length">{{ activeStops.length }}</span>
					</button>
					<button type="button" [class.is-active]="sideTab === 'accounts'" (click)="setSideTab('accounts')">
						My customers <span class="srb-tab-n" *ngIf="allAccounts.length">{{ filteredAccounts().length }}</span>
					</button>
					<button type="button" [class.is-active]="sideTab === 'prospects'" (click)="setSideTab('prospects')">
						New leads <span class="srb-tab-n" *ngIf="prospects.length">{{ matchingProspects().length | number }}</span>
					</button>
					<button type="button" [class.is-active]="sideTab === 'nearby'" (click)="setSideTab('nearby')">
						Near stops <span class="srb-tab-n" *ngIf="activeStops.length && nearbyCount()">{{ nearbyCount() }}</span>
					</button>
				</nav>

				<!-- Route tab -->
				<div class="srb-panel-body" *ngIf="sideTab === 'route'">
					<div class="srb-panel-toolbar">
						<button mat-stroked-button color="accent" type="button" (click)="optimizeRoute()" [disabled]="optimizing || activeStops.length < 2" title="Reorder these stops into the shortest drive">
							<i class="material-icons">alt_route</i> {{ optimizing ? 'Working…' : 'Best driving order' }}
						</button>
						<span class="srb-miles" *ngIf="activeStops.length">
							<i class="material-icons">straighten</i> about {{ activeMiles() | number:'1.0-0' }} mi
						</span>
					</div>
					<div class="srb-daystats" *ngIf="activeStops.length">
						<div class="srb-stat"><span class="v">{{ activeStops.length }}</span><span class="l">stops</span></div>
						<div class="srb-stat"><span class="v">{{ activeMiles() | number:'1.0-0' }}</span><span class="l">miles</span></div>
						<div class="srb-stat" *ngIf="dayLeadCount(activeStops)"><span class="v">{{ dayLeadCount(activeStops) }}</span><span class="l">new leads</span></div>
						<div class="srb-stat is-due" *ngIf="dayDueCount(activeStops)"><span class="v">{{ dayDueCount(activeStops) }}</span><span class="l">due a visit</span></div>
						<div class="srb-stat is-opp" *ngIf="dayOpportunity(activeStops) > 0"><span class="v">${{ dayOpportunity(activeStops) | number:'1.0-0' }}</span><span class="l">/yr potential</span></div>
					</div>
					<div class="srb-list srb-route-list" cdkDropList [cdkDropListData]="activeStops" (cdkDropListDropped)="dropReorder($event)">
						<div class="srb-route-row" *ngFor="let s of activeStops; let i = index" cdkDrag
							[class.is-done]="s.stop_status === 'done'" [class.is-skipped]="s.stop_status === 'skipped'">
							<i class="material-icons srb-drag" cdkDragHandle>drag_indicator</i>
							<span class="srb-seq" [class.is-prospect]="s.stop_type === 'prospect'">{{ i + 1 }}</span>
							<div class="srb-row-main" (click)="openCustomer360(s)" title="Open details">
								<div class="srb-row-name" [title]="accountLabel(s)">
									<span class="srb-name-text">{{ accountLabel(s) }}</span>
									<span class="srb-tag-prospect" *ngIf="s.stop_type === 'prospect'">Prospect</span>
									<span class="srb-tag-status" *ngIf="s.stop_status === 'done'"><i class="material-icons srb-tag-ico">check</i> visited</span>
									<span class="srb-tag-status is-skip" *ngIf="s.stop_status === 'skipped'">skipped</span>
								</div>
								<div class="srb-row-sub srb-row-sub-leg">
									<span class="srb-sub-addr" [title]="stopAddress(s)">{{ stopAddress(s) }}</span>
									<em class="srb-leg" *ngIf="legMiles(i) != null"><i class="material-icons">arrow_forward</i>{{ legMiles(i) | number:'1.0-0' }} mi</em>
								</div>
							</div>
							<button type="button" class="srb-prio" [attr.data-p]="s.priority" (click)="cyclePriority(s)" title="Cycle priority">{{ priorityLabel(s.priority) }}</button>
							<button mat-icon-button type="button" (click)="openCrm(s)" title="CRM notes & follow-ups"><i class="material-icons">sticky_note_2</i></button>
							<button mat-icon-button type="button" (click)="openCheckin(s)" title="Check in"><i class="material-icons">how_to_reg</i></button>
							<button mat-icon-button type="button" (click)="removeFromRoute(i)" title="Remove"><i class="material-icons">close</i></button>
						</div>
						<div class="srb-empty-state" *ngIf="!activeStops.length">
							<i class="material-icons">alt_route</i>
							<p><strong>Nothing planned for {{ activeDayLabel() }} yet.</strong></p>
							<p>Tap a dot on the map to add it, pick from <a (click)="setSideTab('accounts')">My customers</a>, or let the app <a (click)="openAi()">build my week</a> for you.</p>
						</div>
					</div>
				</div>

				<!-- Accounts tab -->
				<div class="srb-panel-body" *ngIf="sideTab === 'accounts'">
					<input class="srb-search" [(ngModel)]="poolSearch" (ngModelChange)="onPoolSearch()" placeholder="Search a customer by name, city or zip…">
					<div class="srb-pool-chips">
						<button type="button" [class.is-active]="poolFilter==='all'" (click)="setPoolFilter('all')">All</button>
						<button type="button" [class.is-active]="poolFilter==='overdue'" (click)="setPoolFilter('overdue')">Due a visit</button>
						<button type="button" [class.is-active]="poolFilter==='never'" (click)="setPoolFilter('never')">Never visited</button>
						<button type="button" [class.is-active]="poolFilter==='priority'" (click)="setPoolFilter('priority')">Top priority</button>
						<button type="button" [class.is-active]="poolFilter==='needs_geo'" (click)="setPoolFilter('needs_geo')">Not on map</button>
					</div>
					<button mat-button type="button" class="srb-geobtn" *ngIf="needsGeoCount()" (click)="bulkGeocodeMissing()" [disabled]="geocoding">
						<i class="material-icons">my_location</i> Put {{ needsGeoCount() }} on the map
					</button>
					<div class="srb-list">
						<div class="srb-pool-row" *ngFor="let a of filteredAccounts()">
							<div class="srb-row-main" (click)="openCustomer360(a)" title="Open customer details">
								<div class="srb-row-name" [title]="accountLabel(a)"><span class="srb-name-text">{{ accountLabel(a) }}</span></div>
								<div class="srb-pool-meta">
									<span class="srb-badge" [class.never]="lastContactDays(a) === null" [class.overdue]="lastContactDays(a) !== null && lastContactDays(a) >= 30">{{ visitBadge(a) }}</span>
									<span class="srb-on-day" *ngIf="onDayLabel(a)">on {{ onDayLabel(a) }}</span>
									<span class="srb-nogps" *ngIf="a.needs_geocode">No GPS</span>
								</div>
							</div>
							<button mat-icon-button type="button" (click)="openCrm(a)" title="CRM notes"><i class="material-icons">sticky_note_2</i></button>
							<button *ngIf="a.needs_geocode" mat-icon-button type="button" (click)="geocodeOne(a)" [disabled]="geocoding" title="Geocode"><i class="material-icons">my_location</i></button>
							<button *ngIf="!a.needs_geocode" mat-stroked-button type="button" color="primary" class="srb-addbtn" (click)="addToRoute(a)" [disabled]="!!onDayLabel(a)">Add</button>
						</div>
						<p class="text-muted srb-empty" *ngIf="loadingAccounts">Loading accounts…</p>
						<p class="text-muted srb-empty" *ngIf="metaLoaded && !loadingAccounts && !filteredAccounts().length">{{ isRep ? 'No customers match — try a different filter or search.' : 'No accounts match. Pick a salesperson or adjust filters.' }}</p>
					</div>
				</div>

				<!-- Prospects tab -->
				<div class="srb-panel-body" *ngIf="sideTab === 'prospects'">
					<input class="srb-search" [(ngModel)]="prospectSearch" (ngModelChange)="onLeadSearch()" placeholder="Search a lead by business, owner or city…">
					<div class="srb-pool-chips" *ngIf="assignedCount()">
						<button type="button" [class.is-active]="leadFilter==='assigned'" (click)="setLeadFilter('assigned')">Assigned to me ({{ assignedCount() }})</button>
						<button type="button" [class.is-active]="leadFilter==='all'" (click)="setLeadFilter('all')">All leads ({{ prospects.length | number }})</button>
					</div>
					<div class="srb-pool-chips srb-dist-chips">
						<span class="srb-dist-lbl">Within:</span>
						<button type="button" [class.is-active]="leadRadius===null" (click)="setLeadRadius(null)">Any</button>
						<button type="button" *ngFor="let r of leadRadiusOptions" [class.is-active]="leadRadius===r" (click)="setLeadRadius(r)">{{ r }} mi</button>
					</div>
					<p class="srb-panel-hint" *ngIf="leadFilter === 'assigned'">Your manager picked these for you — start here.</p>
					<p class="srb-panel-hint" *ngIf="leadFilter === 'all' && leadRadius !== null">Closest first — leads within {{ leadRadius }} miles of home base.</p>
					<p class="srb-panel-hint" *ngIf="leadFilter === 'all' && leadRadius === null">Licensed salons and barbers near you that aren't buying from us yet — biggest first. Add one to a day to go say hello.</p>
					<div class="srb-list">
						<p class="text-muted srb-empty" *ngIf="loadingProspects">Loading leads…</p>
						<div class="srb-pool-row" *ngFor="let p of filteredProspects()">
							<div class="srb-row-main" (click)="openLead(p)" title="Open lead details">
								<div class="srb-row-name" [title]="p.business_name || p.owner"><span class="srb-name-text">{{ p.business_name || p.owner }}</span></div>
								<div class="srb-pool-meta">
									<span class="srb-badge assigned" *ngIf="p.assigned">Assigned to me</span>
									<span class="srb-badge dist">{{ leadDistance(p) | number:'1.0-0' }} mi</span>
									<span class="srb-badge">{{ licenseLabel(p.license_type) }}</span>
									<span class="srb-badge">{{ p.city }} {{ p.zip5 }}</span>
									<span class="srb-pot" *ngIf="p.est_potential">~${{ p.est_potential | number }}/yr</span>
								</div>
							</div>
							<button mat-icon-button type="button" (click)="crmTarget = { prospect_key: p.prospect_key, name: p.business_name || p.owner }" title="CRM notes"><i class="material-icons">sticky_note_2</i></button>
							<button mat-stroked-button type="button" color="primary" class="srb-addbtn" (click)="addProspectToRoute(p)">Add</button>
						</div>
						<p class="text-muted srb-empty" *ngIf="prospectsCapped()">Showing the biggest 400 of {{ matchingProspects().length | number }} — search to find the rest.</p>
						<p class="text-muted srb-empty" *ngIf="!loadingProspects && prospectsAvailable && !filteredProspects().length && prospects.length && leadRadius !== null">No leads within {{ leadRadius }} miles — try a wider distance.</p>
						<p class="text-muted srb-empty" *ngIf="!loadingProspects && prospectsAvailable && !filteredProspects().length && prospects.length && leadRadius === null">You've already added every matching lead to a day. Nice.</p>
						<p class="text-muted srb-empty" *ngIf="!loadingProspects && prospectsAvailable && !prospects.length">No new leads in your area right now.</p>
						<p class="text-muted srb-empty" *ngIf="!prospectsAvailable">Leads aren't turned on for this company yet.</p>
					</div>
				</div>

				<!-- Near my stops tab -->
				<div class="srb-panel-body" *ngIf="sideTab === 'nearby'">
					<div class="srb-empty-state" *ngIf="!activeStops.length">
						<i class="material-icons">explore</i>
						<p><strong>Add a stop first.</strong></p>
						<p>Once {{ activeDayLabel() }} has a stop or two, this shows the customers and leads closest to them so you can fill in the drive.</p>
					</div>
					<ng-container *ngIf="activeStops.length">
						<div class="srb-pool-chips srb-dist-chips">
							<span class="srb-dist-lbl">Within:</span>
							<button type="button" *ngFor="let r of nearbyRadiusOptions" [class.is-active]="nearbyRadiusPlan===r" (click)="setNearbyRadius(r)">{{ r }} mi</button>
							<button type="button" class="srb-nearby-leadtog" [class.is-active]="nearbyIncludeLeads" (click)="toggleNearbyLeads()"><i class="material-icons">storefront</i> Leads</button>
						</div>
						<p class="srb-panel-hint">Customers and leads within {{ nearbyRadiusPlan }} mi of {{ activeDayLabel() }}'s stops — closest first. Rings on the map show the reach.</p>
						<button mat-stroked-button color="primary" type="button" class="srb-addall" *ngIf="nearbyCount()" (click)="addAllNearby()">
							<i class="material-icons">playlist_add</i> Add all {{ nearbyCount() }} to {{ activeDayLabel() }}
						</button>
						<div class="srb-list">
							<div class="srb-pool-row" *ngFor="let r of nearbyToStops()">
								<div class="srb-row-main" (click)="openNearby(r)" title="Open details">
									<div class="srb-row-name" [title]="nearbyName(r)">
										<span class="srb-name-text">{{ nearbyName(r) }}</span>
										<span class="srb-tag-prospect" *ngIf="r.kind === 'lead'">Lead</span>
									</div>
									<div class="srb-pool-meta">
										<span class="srb-badge dist">{{ r.dist | number:'1.1-1' }} mi from route</span>
										<span class="srb-badge" *ngIf="r.kind === 'customer'">{{ nearbyVisit(r) }}</span>
										<span class="srb-badge" *ngIf="nearbyPotential(r)">~${{ nearbyPotential(r) | number }}/yr</span>
									</div>
								</div>
								<button mat-stroked-button type="button" color="primary" class="srb-addbtn" (click)="addNearbyRow(r)">Add</button>
							</div>
							<p class="text-muted srb-empty" *ngIf="!nearbyCount()">Nothing within {{ nearbyRadiusPlan }} mi — widen the radius{{ nearbyIncludeLeads ? '' : ' or turn on leads' }}.</p>
						</div>
					</ng-container>
				</div>
			</aside>

			<!-- Week list view (map alternative) -->
			<div class="srb-weeklist" *ngIf="listView">
				<div class="srb-wl-summary">
					<strong>{{ weekLabel() }}</strong>
					<span>{{ totalStops() }} stops · about {{ weekMiles() | number:'1.0-0' }} mi<ng-container *ngIf="weekOpportunity() > 0"> · ~${{ weekOpportunity() | number:'1.0-0' }}/yr potential</ng-container></span>
				</div>
				<div class="srb-wl-day" *ngFor="let d of plannerDays">
				<div class="srb-wl-dayhd" [class.is-active]="isActiveDay(d)" (click)="selectDay(d)">
						<span class="srb-wl-dayname">{{ d.full }} <em>{{ d.dateShort }}</em></span>
						<span class="srb-wl-daymeta" *ngIf="dayCount(d.weekStart, d.dow) as n">
							{{ n }} stops · {{ dayMiles(stopsForDay(d.weekStart, d.dow)) | number:'1.0-0' }} mi
							<ng-container *ngIf="dayDueCount(stopsForDay(d.weekStart, d.dow)) as due"> · <span class="srb-wl-due" *ngIf="due">{{ due }} due a visit</span></ng-container>
							<ng-container *ngIf="dayOpportunity(stopsForDay(d.weekStart, d.dow)) > 0"> · ~${{ dayOpportunity(stopsForDay(d.weekStart, d.dow)) | number:'1.0-0' }}/yr</ng-container>
						</span>
						<span class="srb-wl-daymeta empty" *ngIf="!dayCount(d.weekStart, d.dow)">no stops</span>
					</div>
					<!-- Active day: draggable to reorder (same drop handler as the Route tab). -->
					<div class="srb-wl-stops" *ngIf="isActiveDay(d) && dayCount(d.weekStart, d.dow)" cdkDropList [cdkDropListData]="activeStops" (cdkDropListDropped)="dropReorder($event)">
						<div class="srb-wl-stop" *ngFor="let s of activeStops; let i = index" cdkDrag
							[class.is-done]="s.stop_status === 'done'" [class.is-skipped]="s.stop_status === 'skipped'">
							<i class="material-icons srb-drag" cdkDragHandle>drag_indicator</i>
							<span class="srb-seq" [class.is-prospect]="s.stop_type === 'prospect'">{{ i + 1 }}</span>
							<div class="srb-wl-info" (click)="openCustomer360(s)">
								<div class="srb-row-name" [title]="accountLabel(s)">
									<span class="srb-name-text">{{ accountLabel(s) }}</span>
									<span class="srb-tag-prospect" *ngIf="s.stop_type === 'prospect'">Lead</span>
								</div>
								<div class="srb-row-sub" [title]="stopAddress(s)">{{ stopAddress(s) }}<em class="srb-leg" *ngIf="legMiles(i) != null"> · {{ legMiles(i) | number:'1.0-0' }} mi</em></div>
							</div>
						</div>
					</div>
					<!-- Other days: read-only (select the day above to reorder it). -->
					<div class="srb-wl-stops" *ngIf="!isActiveDay(d) && dayCount(d.weekStart, d.dow)">
						<div class="srb-wl-stop" *ngFor="let s of stopsForDay(d.weekStart, d.dow); let i = index"
							[class.is-done]="s.stop_status === 'done'" [class.is-skipped]="s.stop_status === 'skipped'">
							<span class="srb-seq" [class.is-prospect]="s.stop_type === 'prospect'">{{ i + 1 }}</span>
							<div class="srb-wl-info" (click)="openCustomer360(s)">
								<div class="srb-row-name" [title]="accountLabel(s)">
									<span class="srb-name-text">{{ accountLabel(s) }}</span>
									<span class="srb-tag-prospect" *ngIf="s.stop_type === 'prospect'">Lead</span>
								</div>
								<div class="srb-row-sub" [title]="stopAddress(s)">{{ stopAddress(s) }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Map -->
			<div class="srb-map-wrap" [class.is-full]="fullMap" [hidden]="listView">
				<div class="srb-draw-tools">
					<!-- Core: always visible, kept compact so it never crowds the map -->
					<button type="button" class="srb-maptype-toggle" (click)="toggleMapType()" [title]="mapTypeId === 'roadmap' ? 'Switch to satellite' : 'Switch to map'">
						<i class="material-icons">{{ mapTypeId === 'roadmap' ? 'satellite' : 'map' }}</i><span>{{ mapTypeId === 'roadmap' ? 'Satellite' : 'Map' }}</span>
					</button>
					<button type="button" (click)="fitRoute()" title="Zoom the map to fit this day">
						<i class="material-icons">center_focus_strong</i><span>Fit</span>
					</button>
					<button type="button" class="srb-prospect-toggle" [class.is-active]="showProspects" (click)="toggleProspects()" [disabled]="loadingProspects" title="Show new leads on the map">
						<i class="material-icons" [class.srb-spin]="loadingProspects">storefront</i><span>Leads</span>
					</button>
					<span class="srb-tool-sep" aria-hidden="true"></span>
					<button type="button" class="srb-tools-toggle" [class.is-active]="toolsExpanded" (click)="toggleTools()" title="More map tools">
						<i class="material-icons">{{ toolsExpanded ? 'expand_less' : 'more_horiz' }}</i><span>Tools</span>
					</button>

					<!-- Expandable: drawing / start-end / recenter / fullscreen -->
					<ng-container *ngIf="toolsExpanded">
						<span class="srb-tool-sep" aria-hidden="true"></span>
						<button type="button" [class.is-active]="drawMode==='lasso'" (click)="setDrawMode(drawMode==='lasso' ? 'none' : 'lasso')" title="Circle customers on the map to add them">
							<i class="material-icons">gesture</i><span>Circle</span>
						</button>
						<button type="button" [class.is-active]="drawMode==='lasso_remove'" (click)="setDrawMode(drawMode==='lasso_remove' ? 'none' : 'lasso_remove')" title="Circle stops to remove them">
							<i class="material-icons">content_cut</i><span>Remove</span>
						</button>
						<button type="button" (click)="selectVisible()" title="Add every customer and lead shown on the map right now">
							<i class="material-icons">select_all</i><span>Add shown</span>
						</button>
						<span class="srb-tool-sep" aria-hidden="true"></span>
						<button type="button" [class.is-active]="settingPoint==='start'" (click)="setPoint('start')" title="Tap the map to set your start point">
							<i class="material-icons">trip_origin</i><span>Set start</span>
						</button>
						<button type="button" [class.is-active]="settingPoint==='end'" (click)="setPoint('end')" title="Tap the map to set your end point">
							<i class="material-icons">flag</i><span>Set end</span>
						</button>
						<span class="srb-tool-sep" aria-hidden="true"></span>
						<button type="button" (click)="recenterMap()" title="Center on where I am now">
							<i class="material-icons">my_location</i>
						</button>
						<button type="button" class="srb-fullbtn" (click)="toggleFullMap()" [title]="fullMap ? 'Exit full screen' : 'Full screen map'">
							<i class="material-icons">{{ fullMap ? 'fullscreen_exit' : 'fullscreen' }}</i>
						</button>
					</ng-container>
				</div>

				<div class="srb-map-legend">
					<span><i class="srb-dot" style="background:#1e88e5"></i>On my route</span>
					<span><i class="srb-dot" style="background:#00897b"></i>My customer</span>
					<span><i class="srb-dot" style="background:#f4a11e"></i>Due a visit</span>
					<span *ngIf="showProspects"><i class="srb-dot" style="background:#fb8c00"></i>New lead</span>
					<span *ngIf="showProspects && assignedCount()"><i class="srb-dot" style="background:#8e24aa"></i>Assigned to me</span>
					<span><i class="srb-dot" style="background:#43a047"></i>Visited</span>
					<span><i class="srb-dot" style="background:#2e7d32"></i>Start</span>
					<span *ngIf="endMode==='custom'"><i class="srb-dot" style="background:#c62828"></i>End</span>
				</div>

				<div #srbMapHost id="srb-map" class="srb-map" role="application" aria-label="Route map"></div>
				<svg #srbLasso class="srb-lasso" hidden><path class="srb-lasso-path"></path></svg>
				<div class="srb-draw-hint" *ngIf="drawHint">{{ drawHint }}</div>

				<!-- Full-map bottom sheet: day switcher + current day's stops -->
				<div class="srb-mobile-sheet" *ngIf="fullMap">
					<div class="srb-ms-tabs">
						<button type="button" *ngFor="let d of plannerDays" [class.is-active]="isActiveDay(d)" (click)="selectDay(d)">
							{{ d.label }}<span *ngIf="dayCount(d.weekStart, d.dow)"> {{ dayCount(d.weekStart, d.dow) }}</span>
						</button>
						<button type="button" class="srb-ms-opt" (click)="optimizeRoute()" [disabled]="optimizing || activeStops.length < 2">Optimize</button>
					</div>
					<div class="srb-ms-list">
						<div class="srb-ms-row" *ngFor="let s of activeStops; let i = index">
							<span class="srb-seq">{{ i + 1 }}</span>
							<span class="srb-ms-name">{{ accountLabel(s) }}</span>
							<button mat-icon-button type="button" (click)="removeFromRoute(i)"><i class="material-icons">close</i></button>
						</div>
						<p class="text-muted srb-empty" *ngIf="!activeStops.length">Lasso accounts on the map to build {{ days[activeDow].label }}.</p>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Check-in modal -->
	<div class="srb-modal-backdrop" *ngIf="checkinStop" (click)="cancelCheckin()"></div>
	<div class="srb-modal" *ngIf="checkinStop">
		<header>
			<h3>Check in — {{ checkinStop.name }}</h3>
			<span class="srb-geo-note" *ngIf="checkinGeo"><i class="material-icons">place</i> GPS attached</span>
		</header>
		<div class="srb-modal-body">
			<label>Outcome</label>
			<select [(ngModel)]="checkinOutcome" class="srb-sel w-100">
				<option *ngFor="let o of checkinOutcomes" [value]="o.v">{{ o.l }}</option>
			</select>
			<label>Notes</label>
			<textarea [(ngModel)]="checkinNotes" rows="3" class="srb-inp w-100" placeholder="Optional notes"></textarea>
		</div>
		<footer>
			<button mat-button type="button" (click)="cancelCheckin()" [disabled]="checkingIn">Cancel</button>
			<button mat-raised-button color="primary" type="button" (click)="doCheckin()" [disabled]="checkingIn">{{ checkingIn ? 'Saving…' : 'Log visit' }}</button>
		</footer>
	</div>

	<!-- Build-my-week modal -->
	<div class="srb-modal-backdrop" *ngIf="showAi" (click)="closeAi()"></div>
	<div class="srb-modal srb-modal-lg" *ngIf="showAi">
		<header><h3><i class="material-icons srb-h3-ico">auto_awesome</i> Build my week</h3></header>
		<div class="srb-modal-body">
			<p class="srb-ai-intro">We'll spread your customers across the week so you drive the least. Pick your days and how busy you want to be.</p>

			<div class="srb-ai-block">
				<label class="srb-ai-lbl">Which days are you working?</label>
				<div class="srb-ai-daychips">
					<button type="button" *ngFor="let d of days" class="srb-ai-daychip" [class.is-on]="aiDays[d.full]" (click)="aiDays[d.full] = !aiDays[d.full]">{{ d.label }}</button>
				</div>
			</div>

			<div class="srb-ai-block">
				<label class="srb-ai-lbl">How many stops a day?</label>
				<div class="srb-ai-pace">
					<button type="button" [class.is-on]="aiPace==='light'" (click)="setAiPace('light')"><strong>Easy</strong><em>~5/day</em></button>
					<button type="button" [class.is-on]="aiPace==='normal'" (click)="setAiPace('normal')"><strong>Normal</strong><em>~8/day</em></button>
					<button type="button" [class.is-on]="aiPace==='full'" (click)="setAiPace('full')"><strong>Packed</strong><em>~11/day</em></button>
				</div>
			</div>

			<a class="srb-ai-advtoggle" (click)="aiAdvanced = !aiAdvanced">{{ aiAdvanced ? 'Hide options' : 'Fine-tune' }}</a>
			<div class="srb-ai-adv" *ngIf="aiAdvanced">
				<div class="srb-ai-row">
					<label>Stops per day</label>
					<span>min <input type="number" class="srb-num" [(ngModel)]="aiMin"> aim <input type="number" class="srb-num" [(ngModel)]="aiTarget"> max <input type="number" class="srb-num" [(ngModel)]="aiMax"></span>
				</div>
				<div class="srb-ai-row">
					<label>Anything special?</label>
					<input class="srb-inp w-100" [(ngModel)]="aiNotes" placeholder="e.g. keep Mondays downtown, see overdue first">
				</div>
			</div>

			<p class="text-muted srb-ai-working" *ngIf="planningAi"><i class="material-icons srb-spin">sync</i> Building your week&hellip; a few seconds.</p>
			<div class="srb-ai-result" *ngIf="aiResult">
				<p class="srb-ai-resulthd">Here's the plan:</p>
				<div class="srb-ai-day" *ngFor="let d of days">
					<strong>{{ d.label }}</strong>: {{ (aiResult.days[d.full] || []).length }} stops
				</div>
				<p class="text-muted" *ngIf="aiResult.unassigned?.length">{{ aiResult.unassigned.length }} didn't fit — still in My customers.</p>
				<p class="srb-ai-reason" *ngIf="aiResult.reasoning">{{ aiResult.reasoning }}</p>
			</div>
		</div>
		<footer>
			<button mat-button type="button" (click)="closeAi()">Cancel</button>
			<button *ngIf="!aiResult" mat-raised-button color="primary" type="button" (click)="runAi()" [disabled]="planningAi || !aiSelectedDayCount()">{{ planningAi ? 'Building&hellip;' : 'Build it' }}</button>
			<button *ngIf="aiResult" mat-stroked-button type="button" (click)="runAi()" [disabled]="planningAi">Try again</button>
			<button *ngIf="aiResult" mat-raised-button color="primary" type="button" (click)="applyAiPlan()">Use this plan</button>
		</footer>
	</div>

	<!-- Save-as-template modal -->
	<div class="srb-modal-backdrop" *ngIf="showTemplateSave" (click)="closeTemplateSave()"></div>
	<div class="srb-modal" *ngIf="showTemplateSave">
		<header><h3>Save {{ days[activeDow].label }} as template ({{ activeStops.length }} stops)</h3></header>
		<div class="srb-modal-body">
			<label>Zone code (e.g. WNY, NYC)</label>
			<input class="srb-inp w-100" [(ngModel)]="tmplZone" placeholder="Zone">
			<label>Template name</label>
			<input class="srb-inp w-100" [(ngModel)]="tmplName" placeholder="e.g. Route 1 - Downtown">
		</div>
		<footer>
			<button mat-button type="button" (click)="closeTemplateSave()">Cancel</button>
			<button mat-raised-button color="primary" type="button" (click)="saveAsTemplate()" [disabled]="!tmplZone.trim() || !tmplName.trim()">Save template</button>
		</footer>
	</div>

	<!-- Territory manager modal -->
	<div class="srb-modal-backdrop" *ngIf="showTerritoryMgr" (click)="closeTerritoryMgr()"></div>
	<div class="srb-modal srb-modal-lg" *ngIf="showTerritoryMgr">
		<header><h3>Territory manager</h3></header>
		<div class="srb-modal-body">
			<label>Territory</label>
			<select class="srb-sel w-100" (change)="loadTerritoryBranches(+$any($event.target).value)">
				<option value="">Pick a territory…</option>
				<option *ngFor="let t of territories" [value]="t.territory_id">{{ t.territory_name }}</option>
			</select>
			<ng-container *ngIf="tmgrId">
				<p class="srb-tmgr-count" *ngIf="tmgrTotal">{{ tmgrTotal | number }} branch{{ tmgrTotal === 1 ? '' : 'es' }} in this territory — search by name, city or account # to find one.</p>
				<input class="srb-search" [(ngModel)]="tmgrSearch" (ngModelChange)="onTmgrSearch()" placeholder="Search this territory…">
				<p class="text-muted" *ngIf="tmgrLoading">Searching…</p>
				<div class="srb-tmgr-list" *ngIf="!tmgrLoading">
					<div class="srb-tmgr-row" *ngFor="let b of tmgrBranches">
						<span class="srb-tmgr-name">{{ b.brname || b.debtor_name || ('#' + b.debtorno) }} <em>{{ b.city }}</em></span>
						<select class="srb-sel" (change)="assignBranch(b, $any($event.target).value)">
							<option value="">Move to…</option>
							<option *ngFor="let t of territories" [value]="t.territory_id">{{ t.territory_name }}</option>
						</select>
					</div>
					<p class="text-muted srb-empty" *ngIf="tmgrSearched && !tmgrBranches.length">No matches — try a different search.</p>
					<p class="text-muted srb-empty" *ngIf="!tmgrSearched">Type above to find a branch.</p>
					<p class="text-muted srb-empty" *ngIf="tmgrBranches.length === 200">Showing the first 200 matches — narrow your search to see more.</p>
				</div>
			</ng-container>
		</div>
		<footer><button mat-button type="button" (click)="closeTerritoryMgr()">Close</button></footer>
	</div>

	<!-- Customer 360 modal -->
	<div class="srb-modal-backdrop" *ngIf="c360" (click)="closeCustomer360()"></div>
	<div class="srb-modal srb-c360" *ngIf="c360">
		<header class="srb-c360-head">
			<div class="srb-c360-title">
				<h3>{{ c360.name || c360.brname }}</h3>
				<span class="srb-c360-tag" *ngIf="c360.stop_type === 'prospect'">New lead</span>
				<span class="srb-c360-tag is-assigned" *ngIf="c360.assigned">Assigned to me</span>
			</div>
			<button mat-icon-button type="button" (click)="closeCustomer360()" aria-label="Close"><i class="material-icons">close</i></button>
		</header>

		<div class="srb-modal-body srb-c360-body">
			<!-- Address + contact line -->
			<div class="srb-c360-addr">
				<i class="material-icons">place</i>
				<span>{{ stopAddress(c360) }}{{ c360.zip ? ', ' + c360.zip : '' }}</span>
			</div>

			<!-- ── Customer variant ─────────────────────────────── -->
			<ng-container *ngIf="c360.stop_type !== 'prospect'">
				<p class="text-muted srb-c360-loading" *ngIf="c360Loading"><i class="material-icons srb-spin">sync</i> Loading customer…</p>

				<div class="srb-c360-stats" *ngIf="c360Detail">
					<div class="srb-c360-stat"><span class="l">Balance</span><span class="v" [class.neg]="c360Detail.balance > 0">{{ c360Detail.balance | currency:'USD':'symbol':'1.0-0' }}</span></div>
					<div class="srb-c360-stat"><span class="l">Sales YTD</span><span class="v">{{ c360Detail.ytd_sales | currency:'USD':'symbol':'1.0-0' }}</span></div>
					<div class="srb-c360-stat"><span class="l">Open orders</span><span class="v">{{ c360Detail.open_orders }}</span></div>
					<div class="srb-c360-stat"><span class="l">Last visit</span><span class="v">{{ c360Detail.last_visit_date ? (c360Detail.last_visit_date | date:'MMM d') : '—' }}</span></div>
				</div>

				<div class="srb-c360-contact" *ngIf="c360Detail?.customer as c">
					<div *ngIf="c.contactname"><i class="material-icons">person</i> {{ c.contactname }}</div>
					<div *ngIf="c.phoneno"><i class="material-icons">call</i> <a href="tel:{{ c.phoneno }}">{{ c.phoneno }}</a></div>
					<div *ngIf="c.email"><i class="material-icons">mail</i> <a href="mailto:{{ c.email }}">{{ c.email }}</a></div>
					<div *ngIf="c.salesmanname"><i class="material-icons">badge</i> {{ c.salesmanname }}</div>
				</div>

				<div class="srb-c360-orders" *ngIf="c360Detail?.recent_orders?.length">
					<h4>Recent invoices</h4>
					<div class="srb-c360-order" *ngFor="let o of c360Detail.recent_orders">
						<span class="d">{{ o.trandate | date:'MMM d, y' }}</span>
						<span class="n">#{{ o.orderno || o.transno }}</span>
						<span class="t">{{ o.total | currency:'USD':'symbol':'1.0-0' }}</span>
					</div>
				</div>
			</ng-container>

			<!-- ── Lead variant ─────────────────────────────────── -->
			<ng-container *ngIf="c360.stop_type === 'prospect'">
				<div class="srb-c360-stats">
					<div class="srb-c360-stat" *ngIf="c360.license_type"><span class="l">Type</span><span class="v">{{ licenseLabel(c360.license_type) }}</span></div>
					<div class="srb-c360-stat is-opp" *ngIf="c360.est_potential"><span class="l">Est. potential</span><span class="v">${{ c360.est_potential | number:'1.0-0' }}/yr</span></div>
					<div class="srb-c360-stat" *ngIf="c360.ops_at_addr && c360.ops_at_addr > 1"><span class="l">At this address</span><span class="v">{{ c360.ops_at_addr }}</span></div>
				</div>
				<p class="srb-c360-twin" *ngIf="c360.est_twin"><i class="material-icons">insights</i> Looks like <strong>{{ c360.est_twin }}</strong></p>
			</ng-container>

			<!-- ── AI backfill ──────────────────────────────────── -->
			<div class="srb-c360-ai">
				<button mat-stroked-button type="button" (click)="c360Backfill()" [disabled]="c360Enriching">
					<i class="material-icons" [class.srb-spin]="c360Enriching">auto_awesome</i>
					{{ c360Enriching ? 'Looking it up…' : 'AI backfill info' }}
				</button>
				<p class="srb-c360-aimsg" *ngIf="c360EnrichMsg">{{ c360EnrichMsg }}</p>
				<div class="srb-c360-enrich" *ngIf="c360Enrich">
					<div *ngIf="c360Enrich.phone"><i class="material-icons">call</i> {{ c360Enrich.phone }}</div>
					<div *ngIf="c360Enrich.website"><i class="material-icons">language</i> <a [href]="c360Enrich.website" target="_blank" rel="noopener">{{ c360Enrich.website }}</a></div>
					<div *ngIf="c360Enrich.hours"><i class="material-icons">schedule</i> {{ c360Enrich.hours }}</div>
					<div *ngIf="c360Enrich.services"><i class="material-icons">content_cut</i> {{ c360Enrich.services }}</div>
					<div *ngIf="c360Enrich.socials"><i class="material-icons">share</i> {{ c360Enrich.socials }}</div>
				</div>
			</div>
		</div>

		<footer class="srb-c360-actions">
			<button mat-raised-button color="primary" type="button" *ngIf="!c360OnDay()" (click)="c360Add()">
				<i class="material-icons">add_location_alt</i> Add to {{ activeDayLabel() }}
			</button>
			<span class="srb-c360-onday" *ngIf="c360OnDay()"><i class="material-icons">check_circle</i> On {{ c360OnDay() }}</span>
			<button mat-stroked-button type="button" (click)="c360Notes()"><i class="material-icons">sticky_note_2</i> Notes</button>
			<button mat-stroked-button type="button" *ngIf="c360.stop_type !== 'prospect'" (click)="c360Checkin()"><i class="material-icons">how_to_reg</i> Check in</button>
			<button mat-stroked-button type="button" *ngIf="c360.stop_type !== 'prospect'" (click)="c360CreateOrder()"><i class="material-icons">receipt_long</i> Create order</button>
			<button mat-stroked-button type="button" *ngIf="c360.stop_type === 'prospect'" (click)="c360CreateCustomer()"><i class="material-icons">person_add</i> Create customer</button>
			<button mat-stroked-button type="button" (click)="c360Directions()"><i class="material-icons">directions</i> Directions</button>
		</footer>
	</div>

	<!-- CRM notes drawer -->
	<div class="srb-modal-backdrop" *ngIf="crmTarget" (click)="closeCrm()"></div>
	<div class="srb-crm-drawer" *ngIf="crmTarget">
		<app-crm-notes-panel [target]="crmTarget" [salesperson]="salesmanCtrl.value || ''" (closed)="closeCrm()"></app-crm-notes-panel>
	</div>
</div>
